const DefaultConfig = {
  appid: '513fe75dd6756c25d3a2ddd1c5f28765',
  appSecret: 'ec72fb9433362893f257e8526b10bd1b', 
  schannel: '014025D',
  projectId: 'AI_CMWW_YYGS',
};

const CommonPubConfig = {
  appid: '64a38a747efb3038c5e2f9268c5fe5b5',
  appSecret: '21f46bcfdbb73883007cb10b856db682',
  schannel: '014X0JQ',
  projectId: 'AI_CMWW_YYGS',
};

// 使用 Proxy 代理配置对象，实现动态切换
export const MiguConfig = new Proxy(DefaultConfig, {
  get: (target, prop) => {
    const commonPub = localStorage.getItem('commonPub');
    const isCommonPub = commonPub === 'true' || commonPub === '1';
    const config = isCommonPub ? CommonPubConfig : DefaultConfig;
    // @ts-ignore
    return config[prop];
  }
});

export const newYearUrl = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/rd2-cdn/migu/newYear/';
